import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Spinner, Button } from "react-bootstrap";
import MonthlyCalendar from "./MontlyCalender";
import { useSelector } from "react-redux";
import useGetAllManagers from "../Common/ReuseApi/useGetAllManagers";
import useGetEmployeesByHierarchy from "../Common/ReuseApi/useGetEmployeesByHierarchy";

const Compliance = ({ employees, filters, setFilters, project, setProject, projectOptions }) => {
  const userState = useSelector((state) => state.loginData.userData);

  const roleOfUser = ["teamlead", "manager"]
  const isEmployee = userState?.resourceType === "employee";
  const [localFilters, setLocalFilters] = useState({
    fromDate: "",
    toDate: "",
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  });

  const [loader, setLoader] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [noData, setNoData] = useState(false);

  const { employeeOptions } = useGetEmployeesByHierarchy();

  const defaultFilters = {
    employeeId: "",
    fromDate: "",
    toDate: "",
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  };

  const activeFilters = isEmployee ? localFilters : (filters || defaultFilters);

  const { employeeId, fromDate, toDate, month, year } = activeFilters;

  const updateFilters = isEmployee ? setLocalFilters : setFilters;

  useEffect(() => {
    getCompliance();
  }, [month, year, employeeId]);

  const getCompliance = async () => {
    setLoader(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BASE_URL + "/task/get/alltask/compailance",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userState?.token}`,
          },
          body: JSON.stringify({
            // empId: employeeId || userState.empId,
            // empId: userState.resourceType === "humanResource" ? "humanResource" :
            //   (userState.resourceType === "manager" && userState.resourceType === "teamlead") ? userState.assignedEmployee : employeeId || userState.empId,
            // empId: employeeId && employeeId.toLowerCase() === "all" ? "" : employeeId || "",
            empId: userState.resourceType === "employee" ? userState.empId : employeeId?.toLowerCase() === "all"
              ? ""
              : employeeId || "",
            assignedEmployee: userState.assignedEmployee,
            resourceType: userState.resourceType,
            month: month,
            year: year,
            proposedStartDate: fromDate,
            proposedEndDate: toDate,
            projectName: project?.label || "",
            projectId: project?.value || "",
          }),
        }
      );

      const res = await response.json();
      if (res.status === 200) {
        setTasks(res.data);
        setNoData(false);
      } else if (res.message === "No Data Found") {
        setTasks([]);
        setNoData(true);
      }
    } catch (Err) {
      console.log("Error while compliance =>", Err);
    } finally {
      setLoader(false);
    }
  };

  const handleLeaveApplied = () => {
    getCompliance();
  };

  // for excel export 
  const handleExportExcel = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BASE_URL + "/task/get/alltask/getAllTaskCompailanceExcel",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userState?.token}`,
          },
          body: JSON.stringify({
            empId: employeeId?.toLowerCase() === "all" ? "all" : employeeId || "",
            // empId: userState.resourceType === "employee" ? userState.empId : employeeId?.toLowerCase() === "all"
            //   ? ""
            //   : employeeId || "",
            assignedEmployee: [],
            resourceType: userState.resourceType,
            month: "",
            year: "",
            proposedStartDate: fromDate || "",
            proposedEndDate: toDate || "",
            projectName: project?.label || "",
            projectId: project?.value || "",
          }),
        }
      );

      const res = await response.json();

      if (res?.status === 200 && res?.excelUrl) {
        window.open(res.excelUrl, "_blank");
      } else {
        alert("Select Employee");
      }
    } catch (error) {
      console.log("Export error:", error);
      alert("Something went wrong while exporting excel");
    }
  };

  const { data: allManagerOptions } = useGetAllManagers({
    resourceType: userState?.resourceType
  }, [userState?.resourceType]);

  const handleClear = () => {
    const resetData = {
      employeeId: "",
      fromDate: "",
      toDate: "",
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      project: "",
    };

    setTasks([]);
    setProject("");

    if (isEmployee) {
      setLocalFilters(resetData);
    } else {
      setFilters(resetData);
    }

    setTimeout(() => {
      getCompliance();
    }, 0);
  };

  return (
    <Container className="outletPadding">
      {/* {userState.resourceType !== "employee" && ( */}
      <Row className="mb-4">
        <Col>
          <div className="d-flex flex-wrap align-items-end gap-3">
            <div>
              <Form.Label>Select Project</Form.Label>
              <Form.Select
                style={{ minWidth: "220px" }}
                value={project?.value || ""}
                onChange={(e) => {
                  const selectedProject = projectOptions?.find(
                    (itm) => itm.value === e.target.value
                  );

                  setProject(selectedProject || "");

                  updateFilters((prev) => ({
                    ...prev,
                    project: selectedProject || "",
                  }));
                }}
              >
                <option value="">Select Project</option>

                {projectOptions?.map((proj) => (
                  <option key={proj?.value} value={proj?.value}>
                    {proj?.label}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div>
              <Form.Label>From Date</Form.Label>

              <Form.Control
                type="date"
                value={fromDate || ""}
                onChange={(e) => {
                  updateFilters((prev) => ({
                    ...prev,
                    fromDate: e.target.value,
                    toDate: "",
                  }));
                }}
                style={{ minWidth: "180px" }}
              />
            </div>

            <div>
              <Form.Label>To Date</Form.Label>

              <Form.Control
                type="date"
                value={toDate || ""}
                min={fromDate}
                onChange={(e) =>
                  updateFilters((prev) => ({
                    ...prev,
                    toDate: e.target.value,
                  }))
                }
                style={{ minWidth: "180px" }}
              />
            </div>

            <div className="d-flex gap-2">
              <Button
                className="primaryBtn"
                onClick={getCompliance}
              >
                Submit
              </Button>

              <Button
                className="clearBtn"
                onClick={() => {
                  handleClear();
                  setProject("");
                }}
              >
                Clear
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      {/* )} */}

      {userState.resourceType !== "employee" && (
        <Row className="my-5 align-items-end">
          <Col
            xs={12}
            md={6}
            className="d-flex align-items-end gap-3"
          >
            <div>
              <Form.Label>Select employee</Form.Label>

              <Form.Select
                style={{ minWidth: "240px" }}
                value={employeeId || ""}
                onChange={(e) => {
                  setTasks([]);

                  updateFilters((prev) => ({
                    ...prev,
                    employeeId: e.target.value,
                  }));
                }}
              >
                <option value="">Select Employee</option>
                <option value="all">All</option>

                {(userState?.resourceType === "humanResource" ||
                  userState?.resourceType === "admin")
                  ? allManagerOptions.map((emp) => (
                    <option key={emp.value} value={emp.value}>
                      {emp.label}
                    </option>
                  ))
                  : employeeOptions.map((emp) => (
                    <option key={emp.value} value={emp.value}>
                      {emp.label}
                    </option>
                  ))}
              </Form.Select>
            </div>

            <div>
              <Button
                className="activeBtn"
                onClick={handleExportExcel}
              >
                Export Excel
              </Button>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            className="d-flex justify-content-md-end gap-2 mt-3 mt-md-0"
          >
            <Form.Select
              style={{ width: "150px" }}
              value={month}
              onChange={(e) =>
                updateFilters((prev) => ({
                  ...prev,
                  month: e.target.value,
                  toDate: "",
                }))
              }
            >
              {Array.from({ length: 12 }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                  {new Date(0, i).toLocaleString("default", {
                    month: "long",
                  })}
                </option>
              ))}
            </Form.Select>

            <Form.Select
              style={{ width: "120px" }}
              value={year}
              onChange={(e) =>
                updateFilters((prev) => ({
                  ...prev,
                  year: e.target.value,
                  toDate: "",
                }))
              }
            >
              {[...Array(2)].map((_, i) => (
                <option
                  key={i}
                  value={new Date().getFullYear() - i}
                >
                  {new Date().getFullYear() - i}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
      )}

      {loader ? (
        <div className="text-center my-4">
          <Spinner size="lg" />
        </div>
      ) : (
        <>
          {/* {noData && (
            <div
              style={{
                background: "#fff3cd",
                color: "#856404",
                padding: "10px",
                borderRadius: "8px",
                marginBottom: "10px",
                textAlign: "center",
                fontWeight: "600",
              }}
            >
              ⚠️ No Data Found
            </div>
          )} */}

          <MonthlyCalendar
            key={employeeId}
            year={year}
            month={month}
            tasks={tasks}
            employeeId={employeeId}
            employees={employees}
            onLeaveApplied={handleLeaveApplied}
          />
        </>
      )}
    </Container>
  );
};

export default Compliance;
